
import React from 'react'
import { formatDate } from '@apex/lib/formatters'
import { Download } from 'react-feather'
import Placeholder from './Placeholder'
import Strong from './Strong'
import Button from './Button'
import Empty from './Empty'
import Text from './Text'
import List from './List'
import { HBox } from './Box'

// TODO: don't fetch plans for Invoices?

/**
 * Invoices component.
 */

export default function Invoices({ team, products, subscriptions, invoices, actions }) {
  return <List>
    {invoices.map((invoice, i) => {
      const last = i == invoices.length - 1
      const s = subscriptions.find(s => s.id == invoice.subscription_id)
      const p = products.find(p => s.plan.product_id)
      return <List.Item key={invoice.id} isLast={last}>
        <Invoice {...invoice} product={p} subscription={s} />
      </List.Item>
    })}
  </List>
}

/**
 * Invoice component.
 */

function Invoice({ id, number, total, url, pdf, status, product, subscription, currency, created_at }) {
  return <React.Fragment>
    <HBox gap={4} grow>
      <Strong>{formatDate(new Date(created_at))}</Strong>
      <Text>{product.name}</Text>
      <Text muted marginLeft="auto" marginRight={4}>${total.toFixed(2)} {currency.toUpperCase()}</Text>
    </HBox>
    <Button is="a" href={pdf} theme="primary" iconBefore={Download}>Download</Button>
  </React.Fragment>
}
